import { render } from "./PaymentDelivery.vue?vue&type=template&id=d6e16644&scoped=true"
import script from "./PaymentDelivery.vue?vue&type=script&lang=js"
export * from "./PaymentDelivery.vue?vue&type=script&lang=js"

import "./PaymentDelivery.vue?vue&type=style&index=0&id=d6e16644&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e16644"]])

export default __exports__